import { AppRoutes } from "@/constants/routes";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";
import { PermissionCode } from "@/constants/permissions";

interface Props {
  permissions: Permiso[]; // { codigo: string, tipo: "R" | "W" }
}

export const RequestsView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseCashRequest = hasAccess(PermissionCode.CASH_REQUEST);
  const canUseCheckRequest = hasAccess(PermissionCode.CHECK_REQUEST);
  const canUseTransferRequest = hasAccess(PermissionCode.TRANSFER_REQUEST);
  const canUseScheduledTransfer = hasAccess(PermissionCode.SCHEDULED_TRANSFER);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseCheckRequest && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.CHECK_REQUESTS)}
        >
          Cheque
        </Link>
      )}

      {canUseCashRequest && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.CASH_REQUESTS)}>
          Efectivo
        </Link>
      )}
      {canUseTransferRequest && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.TRANSFER_REQUESTS)}
        >
          Transferencias
        </Link>
      )}
      {canUseScheduledTransfer && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.SCHEDULED_TRANSFER_REQUESTS)}
        >
          Transferencias programadas
        </Link>
      )}
    </Flex>
  );
};
